module.exports = __webpack_public_path__ + "img/w3_circle_list_white.515b0c85.png";